/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JoinLeaderboardBody
 */
export interface JoinLeaderboardBody {
    /**
     * On a competition accepting both tenders (permittedTenders [FUEL, TOKEN]), set true to spend a held entry token instead of paying Fuel. Ignored on a token-gated competition ([TOKEN] — a token is the only way in) and on a Fuel-only one. A spent token is not a fee waiver: the competition's own entry fee is deposited into the prize pool on the player's behalf, so the seat is funded either way.
     * 
     * @type {boolean}
     * @memberof JoinLeaderboardBody
     */
    useToken?: boolean;
    /**
     * Which occurrence to enter, as a 1-indexed period number. Omit to enter the one currently open, or the next one if the board is between occurrences. A future occurrence is charged AT REGISTRATION, into that occurrence's own prize pool — the place is not held unpaid. Must be a whole number of 1 or more, and must name an occurrence the board is currently offering; a fractional or out-of-range value is rejected rather than silently ignored.
     * @type {number}
     * @memberof JoinLeaderboardBody
     */
    periodNumber?: number;
}

/**
 * Check if a given object implements the JoinLeaderboardBody interface.
 */
export function instanceOfJoinLeaderboardBody(value: object): value is JoinLeaderboardBody {
    return true;
}

export function JoinLeaderboardBodyFromJSON(json: any): JoinLeaderboardBody {
    return JoinLeaderboardBodyFromJSONTyped(json, false);
}

export function JoinLeaderboardBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinLeaderboardBody {
    if (json == null) {
        return json;
    }
    return {
        
        'useToken': json['useToken'] == null ? undefined : json['useToken'],
        'periodNumber': json['periodNumber'] == null ? undefined : json['periodNumber'],
    };
}

export function JoinLeaderboardBodyToJSON(json: any): JoinLeaderboardBody {
    return JoinLeaderboardBodyToJSONTyped(json, false);
}

export function JoinLeaderboardBodyToJSONTyped(value?: JoinLeaderboardBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'useToken': value['useToken'],
        'periodNumber': value['periodNumber'],
    };
}

